<template>
  <v-content>
    <br>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="9" md="5" lg="4">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>Gisers Uniformes</v-toolbar-title>
            </v-toolbar>
            <v-row align="center" justify="center">
              
              <v-col cols="12" sm="12" md="12" align="center" justify="center">
                
              </v-col>
            </v-row>

            <v-card-text v-if="continuar && !procesFinally">
              <StreamBarcodeReader
                @decode="(a, b, c) => onDecode(a, b, c)"
                @loaded="() => onLoaded()"
              ></StreamBarcodeReader>
              <br>
              <v-text-field v-model="text" label="Codigo Manual" required outlined></v-text-field>  
              <div class="text-center">
                <v-btn color="primary" @click="getCodes(text)" :disabled="!text">OK</v-btn>
              </div>
            </v-card-text>
            <h3 v-else-if="procesFinally">
              - Proceso finalizado, gracias
            </h3>
            <h3 v-else>
              - Validando... un momento por favor
            </h3>

          </v-card>
        </v-col>
      </v-row>
    </v-container>

  </v-content>
</template>

<script>
import { host, getPublicIP } from '../tools'
import router from '../router';
import swal from 'sweetalert';
import { StreamBarcodeReader } from "vue-barcode-reader";
import { activateBarcodeProccess, agregateProduct, getProductByName, getBarcodeById } from '../dataApi';
export default {
  name: 'Barcode',
  components: {
    StreamBarcodeReader
  },
  data: function () {
    return {
      continuar: false,
      text: '',
      id: null,
      codes: [],
      context: null,
      procesFinally: false
    }
  },
  async mounted(){
    try {
      getPublicIP()
      const code = this.$route.query.entrega;
      const activate = await activateBarcodeProccess(code)
      if(activate?.active) this.activateProcess(activate)
    } catch (error) {
  console.log("Alex", error)
      swal('', "Se ha generado un error al regenerar su nueva clave", 'error')
      //router.push('/login')
    }
  },
  methods: {
    login(){
      router.push('login')
    },

    onDecode(a, b, c) {
      console.log(a, b, c);
      this.text = a;
      this.getCodes(a);
      if (this.id) clearTimeout(this.id);
      this.id = setTimeout(() => {
        if (this.text === a) {
          this.text = "";
        }
      }, 5000);
    },
    onLoaded() {
      console.log("load");
    },
    async getCodes(code) {
      const product = await getProductByName(code)
      if(product) {
        this.text = ''
        const setFinal = await swal({
          text: `Desea agregar: \n 
          ${product.name} \n 
          ${product.description}`,
          icon: "info", buttons: ["Cancelar", "Continuar"]
        })
        if(!setFinal) {
            return false
        } else {
          await agregateProduct({
            product: code,
            quantity: 1,
            active: true,
            barcodeId: this.context?.id
          })
          return false
        }
      } else {
        swal('', "Producto no encontrado", 'error')
        return false
      }
    },
    activateProcess(activate){
      this.continuar = true
      this.context = activate
      this.finallyProcess()
    },
    async finallyProcess(){
      if(!this.procesFinally && this.continuar){
        const response = await getBarcodeById(this.context?.id)
        if(!response?.active){
          this.procesFinally = true
        } else {
          setTimeout(() => {
            this.finallyProcess()
          }, 5000);
        }
      }
    }
  }
}
</script>